import axios from 'axios';
import { apiEndpoint } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const approvalService = {
  create,
  list,
};

function create({ model, objectId, status, comment }) {
  return axios
    .post(
      apiEndpoint.approvals,
      {
        approval: {
          model,
          object_id: objectId,
          status,
          comment,
        },
      },
      {
        headers: authHeader(),
      }
    )
    .then((res) => {
      if (res && res.status === 200) {
        return res.data;
      }
      return {};
    });
}

function list({ model, objectId }) {
  return axios
    .get(
      `${apiEndpoint.approvals}?model=${model}&object_id=${objectId}`,
      {
        headers: authHeader(),
      }
    )
    .then((res) => {
      if (res && res.status === 200) {
        return res.data;
      }
      return {};
    });
}
